import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import reduxConnectContainer from './Deviousness.container';
import { default as Deviousness, Props as WidgetProps } from './Deviousness';

const enhance = compose<React.ComponentClass<WidgetProps & WidgetBoxProps & WithTranslation>>(reduxConnectContainer, withTranslation());

export interface State {
  showDeviationPicker: boolean;
}
class DeviousnessBox extends React.Component<
  WidgetProps & WidgetBoxProps & WithTranslation,
  State
> {
  state: State = {
    showDeviationPicker: false,
  };
  render() {
    const {
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      section,
      zone,
      className,
      moduleId,
      moduleVersion,
      dateAwarded,
      description,
      t,
    } = this.props;

    return (
      <WidgetBox
        section={section}
        zone={zone}
        moduleId={moduleId}
        header={t('widgets.deviousness.header')}
        autoShowWidgetConfig={true}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
      >
        <Deviousness
          className={className}
          moduleId={moduleId}
          moduleVersion={moduleVersion}
          dateAwarded={dateAwarded}
          description={description}
        />
      </WidgetBox>
    );
  }
}

export default enhance(DeviousnessBox) as React.ComponentType<{}>;
